// Sizes dynamic (performance / custom) columns to the longest content they
// hold so the value/header is fully visible and no truncation tooltip is
// needed. Width is clamped, and the returned `limit` is the max characters
// that fit so `TextWithTooltip` only truncates in the rare over-cap case.
const DYNAMIC_COL_CHAR_PX = 8;
const DYNAMIC_COL_PADDING = 32;
const DYNAMIC_COL_HEADER_ICON_CHARS = 4;
const DYNAMIC_COL_MIN_WIDTH = 120;
const DYNAMIC_COL_MAX_WIDTH = 360;

export function getDynamicColumnSizing(
  headerText: string,
  values: string[]
): { width: number; limit: number } {
  const maxValueLen = values.reduce(
    (max, value) => Math.max(max, value?.length ?? 0),
    0
  );
  const headerLen = (headerText?.length ?? 0) + DYNAMIC_COL_HEADER_ICON_CHARS;
  const contentChars = Math.max(maxValueLen, headerLen);

  const rawWidth = contentChars * DYNAMIC_COL_CHAR_PX + DYNAMIC_COL_PADDING;
  const width = Math.min(
    DYNAMIC_COL_MAX_WIDTH,
    Math.max(DYNAMIC_COL_MIN_WIDTH, Math.round(rawWidth))
  );

  const fitChars = Math.floor(
    (width - DYNAMIC_COL_PADDING) / DYNAMIC_COL_CHAR_PX
  );
  return { width: 100, limit: 15 };

  // return { width, limit: Math.max(fitChars, 1) };
}
